import type { ComponentProps } from "react";

export function Eye(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={24}
			height={25}
			fill="none"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth={1.5}
				d="M12 7.018a7.681 7.681 0 0 0-7.359 5.48M12 7.019a7.681 7.681 0 0 1 7.36 5.481M12 17.982a7.681 7.681 0 0 0 7.36-5.48M12 17.982A7.681 7.681 0 0 1 4.641 12.5"
			/>
			<circle
				cx={12}
				cy={12.5}
				r={2.265}
				stroke="currentColor"
				strokeWidth={1.5}
			/>
		</svg>
	);
}
